var MDB = window.MDB || {};
(function ($) {
    MDB.KendoConfigBuilder = MDB.KendoConfigBuilder || {};

    $.extend(MDB.KendoConfigBuilder,
        {
            largeColumnWidth: 250,
            mediumLargeColumnWidth: 200,
            mediumColumnWidth: 150,
            smallColumnWidth: 75,
            extraSmallColumnWidth: 50,
            
            boolDropdownFilter: function (trueText, falseText, bothText) {
                return {
                    operators: {
                        string: {
                            eq: 'Is'
                        }
                    },
                    cell: {
                        showOperators: false,
                        template: function (args) {
                            args.element.kendoDropDownList({
                                dataTextField: 'text',
                                dataValueField: 'value',
                                dataSource: [
                                    {
                                        text: trueText || MDB.loadResourceString('Settings_Analytics_IsEnabled_Filter_True'),
                                        value: 'true'
                                    },
                                    {
                                        text: falseText || MDB.loadResourceString('Settings_Analytics_IsEnabled_Filter_False'),
                                        value: 'false'
                                    }
                                ],
                                index: 0,
                                optionLabel: {
                                    text: bothText || MDB.loadResourceString('Settings_Analytics_IsEnabled_Filter_All'),
                                    value: ''
                                },
                                valuePrimitive: true,
                                dataBound: function (e) {
                                    this.list.outerWidth(this.wrapper.outerWidth());
                                },
                                open: function (e) {
                                    this.list.outerWidth(this.wrapper.outerWidth());
                                }
                            });
                        }
                    }
                }
            },
            extendablebleMultiDropdown: function (selector, config, maxItemLength) {
                selector = $(selector);

                config = $.extend({
                    dataTextField: 'Text',
                    dataValueField: 'Value'
                }, config || {});

                var kMultiSelect = selector.kendoMultiSelect(config).data('kendoMultiSelect');

                var multiSelectInput = selector.siblings().find('input');

                multiSelectInput.on('keydown change', function (e) {
                    var isKeyDown = e.type === 'keydown';

                    //Tab/Enter/Spacebar
                    if (!isKeyDown || (e.which === 9 || e.which === 13 || e.which === 32)) {
                        var value = this.value.replace(' ', '');

                        var backgroundColor = '#FFFFFF';
                        maxItemLength = maxItemLength || 25;

                        if (value.length > 0 && value.length <= maxItemLength) {
                            e.preventDefault();

                            var values = kMultiSelect.value().slice();

                            if (values.indexOf(value) !== -1) return;

                            var dataSource = kMultiSelect.dataSource;
                            var data = dataSource.data();

                            if (!_.find(data, { value: value })) {
                                var newValue = {};
                                newValue[config.dataTextField] = value;
                                newValue[config.dataValueField] = value;

                                data.push(newValue);
                                dataSource.data(data);
                            }

                            dataSource.filter({});
                            values.push(value);

                            kMultiSelect.value(values);
                            
                            if (config.change)  config.change.call(kMultiSelect);
                        } else {
                            if (isKeyDown && !!value) backgroundColor = '#d73925';
                        }

                        selector.siblings('.k-multiselect-wrap.k-floatwrap').css({
                            'background-color': backgroundColor
                        });
                    }
                });

                return kMultiSelect;
            },
            commandLabels: function () {
                return {
                    excel: MDB.loadResourceString('DataTable_Kendo_Action_Excel'),
                    create: MDB.loadResourceString('DataTable_Kendo_Action_Create'),
                    edit: MDB.loadResourceString('DataTable_Kendo_Action_Edit'),
                    destroy: MDB.loadResourceString('DataTable_Kendo_Action_Destroy'),
                    update: MDB.loadResourceString('DataTable_Kendo_Action_Update'),
                    canceledit: MDB.loadResourceString('DataTable_Kendo_Action_CancelEdit')
                }
            },
            dataSourceTransportFunction: function (url, method, options) {

                var ajaxOptions =  {
                    url: url,
                    method: method,
                    contentType: 'application/json',
                    success: function (result) {
                        if(result === null)
                            console.warn('result for "' + url + '" was null');
                        else
                            options.success(result);
                    },
                    error: function (result) { 
                        options.error(result) 
                    }
                };

                switch (method) {                  
                    case 'POST':
                    case 'PUT':
                        ajaxOptions.data = kendo.stringify(MDB.stripDateTimezones(options.data));
                        break;
                    case 'DELETE':
                        var params = kendo.parseQueryStringParams(url);
                        if (!MDB.KendoConfigBuilder.getModelIdColumnValue(params))
                            params.Id = MDB.KendoConfigBuilder.getModelIdColumnValue(options.data);
                        
                        ajaxOptions.url = url.split('?')[0] + '?' + $.param(params);
                        break;
                }

                return $.ajax(ajaxOptions);
            },
            dataSourceHybridClientServerRead: function (kendoControl, ajaxSettings, parentIdField) {
                // Reads server data for a KendoUI widget and switches it to client-side operations if all results are returned at once. 
                return function(options) {
                    var kendoWidget = MDB.KendoConfigBuilder.getKendoWidget(kendoControl);
                    var isTree = kendoWidget instanceof kendo.ui.TreeList;
                    var isHierarchy = kendoWidget instanceof kendo.ui.TreeView;
                    var data = options.data;
                    var filter = data.filter;
                    var storedData = $('th[data-field="' + kendoWidget.wrapper.data('field') + '"]').data('filterValues');
                    var parameterMap = kendoWidget.dataSource.options.transport.parameterMap;
                    
                    if (parameterMap) {
                        data = parameterMap(data, 'read');
                    }

                    if (storedData) {
                        switchDataSoureToLocal(kendoWidget, storedData);
                    } 
                    else {
                        //Prevent previous filter from being reused when no filter is applied
                        if (ajaxSettings.data && ajaxSettings.data.filter)
                            delete ajaxSettings.data.filter;

                        if (!ajaxSettings.data) {
                            ajaxSettings.data = data;
                        }
                        else {
                            $.extend(true, ajaxSettings.data, data);
                        }
                                        
                        ajaxSettings.success = function (result) {
                            var isWholeSet = result.Data.length === result.Total;
                            var isFirstRequest = ajaxSettings.data.firstRequest;
                            var hasFilter = filter && filter.filters.some(function (f) {
                                return f.value;
                            });
                            
                            if (isFirstRequest && isHierarchy) {
                                var hash = {};

                                result.Data.forEach(function(item) {
                                    var id = item['Id'];
                                    var parentId = item[parentIdField || 'ParentId'];

                                    hash[id] = hash[id] || [];
                                    hash[parentId] = hash[parentId] || [];

                                    item.items = hash[id];
                                    hash[parentId].push(item);
                                });

                                result.Data = hash[null];
                            }

                            if (isWholeSet && !hasFilter && ((!isTree && !isHierarchy) || isFirstRequest)) {
                                switchDataSoureToLocal(kendoWidget, result, isTree, isHierarchy);
                            }
                            else {
                                options.success(result);
                            }


                            // This are meant to only be sent on the initial data fetching.
                            delete ajaxSettings.data.firstRequest;
                            delete ajaxSettings.data.maxResults;
                        };

                        $.ajax(ajaxSettings);
                    }                   
                };

                function switchDataSoureToLocal(kendoWidget, result, isTree, isHierarchy) {
                    var localDataSource;
                    var dataSourceOptions = kendoWidget.dataSource.options;
                    var localDataSourceOptions = {
                        transport: dataSourceOptions.transport,
                        pageSize: dataSourceOptions.pageSize,
                        schema: dataSourceOptions.schema,
                        sort: dataSourceOptions.sort,
                        requestEnd: dataSourceOptions.requestEnd
                    };

                    localDataSourceOptions.transport.read = function(options) {
                        return options.success(result.Data);
                    };

                    if (isTree) {
                        localDataSourceOptions.schema.model.expanded = true;
                        localDataSource = new kendo.data.TreeListDataSource(localDataSourceOptions);
                    }
                    else if (isHierarchy) {
                        localDataSourceOptions.schema.model.expanded = true;
                        localDataSourceOptions.schema.model.children = 'items';
                        localDataSource = new kendo.data.HierarchicalDataSource(localDataSourceOptions);
                    }
                    else {
                        localDataSource = new kendo.data.DataSource(localDataSourceOptions);
                    }

                    kendoWidget.setDataSource(localDataSource);

                    // TODO: Remove when have a more recent version of KendoUI.
                    if (isTree) {
                        // Workaround for a bug in the TreeList's setDataSource implementation.
                        kendoWidget._sortable();
                        kendoWidget._filterable();
                    }

                    localDataSource.success(result);

                    if (kendoWidget.columns) {
                        storeComboboxFiltersData(kendoWidget.columns, result.Data);

                        var duplicateFilters = $(kendoWidget.thead).find('.k-filter-row:not(:last)');
                        if (duplicateFilters.length){
                            //After switching to a local datasource, the filters seem to be rendered a second time
                            //Remove the first set of filters
                            duplicateFilters.remove();
                        }
                    }
                    else {
                        var field = kendoWidget.wrapper.data('field');
                        $('th[data-field="' + field + '"]').data('filterValues', result);
                    }
                }

                // Stores the dropdown filter options in a way that can be shared between multiple filter inputs.
                function storeComboboxFiltersData(columns, data) {
                    _.forEach(columns, function (column) {
                        if (column.filterable) {
                            if ((column.filterable.ui && column.filterable.ui.name === 'comboBox') ||
                                (column.filterable.cell && column.filterable.cell.template && column.filterable.cell.template.name === 'comboBox'))
                            {   
                                var field = column.field;
                                var nonEmptyItems = _.filter(data, field);
                                var sortedItems = _.sortBy(nonEmptyItems, field);
                                var uniqueSortedItems = _.sortedUniqBy(sortedItems, field);
                                var values = _.map(uniqueSortedItems, field);

                                $('th[data-field="' + field + '"]').data('filterValues', { Data: values });
                            }
                        }
                    });
                }
            },
            dataSourceLocalJsonTransport: function (storageElement, mappingFunction, idName, idSeed) {
                return {
                    read: function (options) {
                        var localData = JSON.parse(storageElement.val() || '[]');
                        if (idSeed !== undefined) {
                            localData.forEach(function (item) {
                                item[idName] = idSeed++;
                            });
                        }

                        storageElement.val(JSON.stringify(localData));
                        options.success(localData);
                    },
                    create: function (options) {
                        var localData = JSON.parse(storageElement.val() || '[]');
                        var newItem = {};
                        options.data[idName] = idSeed++;
                        if (mappingFunction) {
                            _.mergeWith(newItem, options.data, mappingFunction);
                        } else {
                            _.merge(newItem, options.data);
                        }

                        localData.push(newItem);

                        storageElement.val(JSON.stringify(localData));
                        options.success(options.data);
                    },
                    update: function (options) {
                        var localData = JSON.parse(storageElement.val() || '[]');

                        for (var i = 0; i < localData.length; i++) {
                            if (localData[i][idName] === options.data[idName]) {
                                if (mappingFunction) {
                                    _.mergeWith(localData[i], options.data, mappingFunction);
                                }
                                else {
                                    _.merge(localData[i], options.data);
                                }

                                break;
                            }
                        }

                        storageElement.val(JSON.stringify(localData));
                        options.success(options.data);
                    },
                    destroy: function (options) {
                        var localData = JSON.parse(storageElement.val() || '[]');

                        for (var i = 0; i < localData.length; i++) {
                            if (localData[i][idName] === options.data[idName]) {
                                localData.splice(i, 1);

                                break;
                            }
                        }

                        storageElement.val(JSON.stringify(localData));
                        options.success(localData);
                    }
                }
            },
            dataSourceOffsetUTFDatesToLocalTime: function () {
                return function (e) {
                    if (e.response && e.response.Data && e.response.Data.length) {
                        var data = e.response.Data;

                        for (var i = 0; i < data.length; i++) {
                            var obj = data[i];

                            for (var name in obj) {
                                var prop = obj[name];
                                if (typeof (prop) === 'string' && prop.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
                                    obj[name] = moment.utc(prop).format();
                                }
                            }
                        }
                    }
                }
            },
            getKendoWidget: function (element) {
                var kendoWidgetType;

                switch(element.data('role')) {
                    case 'dropdownlist':
                        kendoWidgetType = 'kendoDropDownList';
                        break;
                    case 'combobox':
                        kendoWidgetType = 'kendoComboBox';
                        break;
                    case 'multiselect':
                        kendoWidgetType = 'kendoMultiSelect';
                        break;
                    case 'grid':
                        kendoWidgetType = 'kendoGrid';
                        break;
                    case 'treelist':
                        kendoWidgetType = 'kendoTreeList';
                        break;
                    case 'treeview':
                        kendoWidgetType = 'kendoTreeView';
                        break;
                }

                return element.data(kendoWidgetType);
            },
            getWebApiErrorsMessage: function (e) {
                var errorMessage = e.errorThrown ? (e.errorThrown + '\n') : '';
                var responseJSON = e.xhr ? e.xhr.responseJSON : e.responseJSON;

                var exceptionMessage = responseJSON.ExceptionMessage || responseJSON.Message;
                var modelStateErrors = responseJSON.ModelState;

                if (modelStateErrors) {
                    errorMessage += MDB.loadResourceString('Shared_Error_InvalidInput') + '\n';
                    for (var key in modelStateErrors) {
                        for (var i = 0; i < modelStateErrors[key].length; i++) {
                            errorMessage += _.last(key.split('.')) + ': ' + modelStateErrors[key][i] + '\n';
                        }
                    }
                }
                else if (exceptionMessage) {
                    errorMessage += exceptionMessage;
                }

                return errorMessage;
            },
            gridBooleanYesNoTemplate: function (fieldName) {
                return sprintf("#= %s ? '%s' : '%s' #",
                    fieldName,
                    MDB.loadResourceString('Bool_Yes'),
                    MDB.loadResourceString('Bool_No'));
            },
            gridDateTimeTemplate: function (fieldName, format) {
                format = format !== undefined ? format : 'yyyy/MM/dd hh:mm';
                return sprintf('#= kendo.toString(kendo.parseDate(%s), \'%s\') #', fieldName, format);
            },
            getModelIdColumnValue: function(model){
                var modelKeys = _.keys(model);
                var idKey = _.find(['id', 'Id', 'ID'], function (key) {
                   return modelKeys.indexOf(key) !== -1;
                });
                
                return model[idKey];
            },
            gridCheckboxTemplate: function (fieldName, className, disabled, excludedId) {
                var template =
                    '<div style="text-align: center;">' +
                    '<input id="' + fieldName + '_#=MDB.KendoConfigBuilder.getModelIdColumnValue(data)#" data-field="' + fieldName + '" type="checkbox" class="' + className + '"' +
                    '#if(' + fieldName + ') {# checked #}# ' +
                    '#if(' + disabled + ' || MDB.KendoConfigBuilder.getModelIdColumnValue(data) === "' + excludedId + '") {# disabled #}#' +
                    ' />' +
                    '</div>';

                return template;
            },
            gridArrayTemplate: function(fieldName, separator){
                if(separator === undefined){
                    separator = ', ';
                }
                
                // return sprintf('# console.log(FollowupChannels.join(\', \')) # JA', fieldName);
                
                return sprintf('#= (%s || []).join(\'%s\') #', fieldName, separator);
            },
            gridCheckboxEditor: function (container, opts) {
                container = $(container);

                var template = MDB.KendoConfigBuilder.gridCheckboxTemplate(opts.field);
                var kTemplate = new kendo.template(template);

                container.on('click',
                    'input[data-field="' + opts.field + '"]',
                    function () {
                        opts.model.set(opts.field, this.checked);
                    });

                return container.append(kTemplate(opts.model));
            },
            gridCommandColumn: function (commands, width, title) {

                return {
                    title: title || '',
                    attributes: { style: 'text-align: center' },
                    command: commands,
                    width: width || 200
                }
            },
            gridColumnMenuRemoveFilterFor: function (fields, separatorIndexes) {
                return function (e) {
                    var fieldsArr = _.isArray(fields) ? fields : [fields];
                    var indexArr = _.isArray(separatorIndexes) ? separatorIndexes : [separatorIndexes];

                    for (var i = 0; i < fieldsArr.length; i++) {
                        var field = fieldsArr[i];

                        if (e.field === field) {
                            var menu = e.container.find('.k-menu').data('kendoMenu');
                            menu.remove('.k-filter-item');
                            menu.remove('.k-separator:eq(' + indexArr[i] + ')');
                        }
                    }
                }
            },
            gridGlobalFilterableSettings: function () {
                return {
                    mode: 'row, menu',
                    operators: {
                        date: _.pick(kendo.ui.FilterCell.fn.options.operators.date, ['lte', 'gte'])
                    }
                }
            },
            gridToolbarCustomCommandTemplate: function (name, href, fieldsMap, hardcodedParams, textOrResourceName, iconClass, typeKey) {
                var params = hardcodedParams || {};
                var icon = 'k-icon ' + (iconClass || 'k-add');
                var text = MDB.loadResourceString(textOrResourceName) ||
                    textOrResourceName ||
                    MDB.loadResourceString('DataTable_Kendo_Action_Create');
                var template = '';

                if (!_.isEmpty(params)) {
                    href += href.indexOf('?') === -1 ? '?' : '&' + $.param(params);
                };

                if (_.isArray(fieldsMap)) {
                    fieldsMap.forEach(function(field) {
                        fieldsMap[field] = field;
                    });
                }

                if (fieldsMap) {
                    var fields = Object.keys(fieldsMap);
                    fields.forEach(function (field) {
                        href += href.indexOf('?') === -1 ? '?' : '&';
                        href += fieldsMap[field] + '=#=' + field + '#';
                    });
                }

                if (typeKey) {
                    href += href.indexOf('?') === -1 ? '?' : '&';

                    template += '<div class="dropdown">' +
                        '<a class="k-button k-button-icontext k-grid-' + name + ' dropdown-toggle" data-toggle="dropdown">' +
                            '<span class="' + icon + '"></span>' + text +
                        '</a>' +
                        '<ul class="dropdown-menu">' +
                        '#var types = MDB.getDivisionChildTypes(data.' + typeKey + ');#' +
                        '#Object.keys(types).forEach(function (t) { #' +
                            '<li class="dropdown-item">' +
                                '<a href="' + href + 'type=#=t#">#=types[t]#</a>' +
                            '</li>' +
                        '# }); #' +
                        '</ul>' +
                        '</div>';
                }
                else {
                    template =
                        '<a class="k-button k-button-icontext k-grid-' + name + '" href="' + href + '">' +
                        '<span class="' + icon + '"></span>' + text +
                        '</a>';
                }

                return template;
            },
            gridCustomDeleteCommand: function (promptTitle, promptBody, deleteUrl) {
                return {
                    name: 'delete-custom',
                    text: MDB.loadResourceString('DataTable_Kendo_Action_Destroy'),
                    imageClass: 'k-icon k-delete',
                    click: function (e) {
                        e.preventDefault();
                        e.stopPropagation(); // Prevents triggering prompt for parent grids in a hierarchy.

                        var gridData = this;
                        var dataRow = ($(e.currentTarget).closest('tr'));
                        var dataItem = this.dataItem(dataRow);

                        MDB.prompt(
                            promptTitle,
                            typeof promptBody === 'function' ? promptBody.call(this, dataItem) : promptBody,
                            function (ok) {
                                if (ok) {
                                    if (deleteUrl) {
                                        MDB.KendoConfigBuilder.dataSourceTransportFunction(deleteUrl,
                                            'DELETE',
                                            {
                                                data: dataItem,
                                                success: function () {
                                                    MDB.KendoConfigBuilder.goBackToLastPageIfGridIsEmpty(gridData); 
                                                    gridData.removeRow(dataRow);
                                                },
                                                error: function (xhr) {
                                                    if (xhr && xhr.responseJSON && xhr.responseJSON.Message) {
                                                        MDB.alert(xhr.responseJSON.Message,
                                                            'Fout bij verwijderen record');
                                                    }
                                                }
                                            });
                                    } else {
                                        MDB.KendoConfigBuilder.goBackToLastPageIfGridIsEmpty(gridData);
                                        gridData.removeRow(dataRow);
                                    }
                                }
                            }
                        );
                    }
                }
            },
            gridCustomLinkCommand: function (name, href, fieldArr, hardcodedParams, textOrResourceName, iconClass) {
                return {
                    name: name,
                    imageClass: 'k-icon ' + (iconClass || 'k-edit'),
                    text: MDB.loadResourceString(textOrResourceName) || textOrResourceName || MDB.loadResourceString('DataTable_Kendo_Action_Edit'),
                    click: function (e) {
                        e.preventDefault();
                        e.stopPropagation(); // Prevents triggering prompt for parent grids in a hierarchy.

                        var dataItem = this.dataItem($(e.currentTarget).closest('tr'));
                        var params = hardcodedParams || {};
                        if ($.isArray(fieldArr)) {
                            if (_.isString(fieldArr[0]) && fieldArr[0].toLowerCase() === 'id') {
                                href += '/' + dataItem[fieldArr[0]];
                                fieldArr.shift();
                            }

                            params = _.merge(params, _.pick(dataItem, fieldArr));
                        }

                        if (!_.isEmpty(params)) {
                            href += '?' + $.param(params);
                        }

                        window.location.href = href;
                    }
                }
            },
            goBackToLastPageIfGridIsEmpty: function (gridData) {
                var pages = gridData.dataSource.totalPages();

                if (pages !== 0 && pages < gridData.dataSource.page()) {
                    gridData.dataSource.page(pages);
                }

            },
            gridStringFilter: function (url, field, maxClientData) {
                return {
                    cell: {
                        template: function comboBox(args) {
                            createComboboxFilter(args.element);
                        },
                        operator: 'contains',
                        suggestionOperator: 'contains'
                    },
                    ui: function comboBox(element) {
                        createComboboxFilter(element);

                        //Force execution at a later time ensuring the menu has been initiated
                        setTimeout(function () {
                            setPopupParentFiltersToValue(element, 'contains')
                        }, 0);
                    }
                };

                function setPopupParentFiltersToValue(popupChildElement, preferredFilter){
                    $(popupChildElement).closest('.k-filter-menu').find('.k-dropdown:not([class*="k-filter"]) select').each(function () {
                        var kDropdown = $(this).data('kendoDropDownList');
                        var ds = kDropdown.dataSource;
                        
                        if (_.map(ds.data(), 'value').indexOf(preferredFilter) !== -1) {
                            kDropdown.value(preferredFilter);
                            kDropdown.trigger('change');
                        }
                    });
                }
                
                function createComboboxFilter(element) {
                    var flag = true;
                    var config =  {
                        autoBind: false,
                        dataSource: {
                            transport: {
                                read: MDB.KendoConfigBuilder.dataSourceHybridClientServerRead(
                                    element,
                                    { url: url + (url.indexOf('?') === -1 ? '?' : '&') + 'field=' + field }
                                )
                            },
                            schema: {
                                data: 'Data',
                                total: 'Total'
                            },
                            pageSize: maxClientData || 500,
                            serverPaging: true,
                            serverFiltering: true
                        },
                        placeholder: 'Type to suggest',
                        filter: 'contains',
                        dataBound: function(e) {
                            var list = this.list;
                            var ul = list.find('ul').get(0);
                            
                            // Firefox doesn't seem to take scrollbars into consideration when calculating width with "max-content".
                            if (ul.scrollWidth > ul.clientWidth) {
                                var items = $(ul).find('.k-item');
                                items.css('padding-right', parseInt(items.css('padding-right')) + kendo.support.scrollbar());
                            }

                            list.outerWidth(this.wrapper.outerWidth());
                        },
                        open: function(e) {
                            // When the grid filter takes effect it seems to remove the combobox's internal filter
                            // if it is filterng on the client side. This will re-apply it manually.
                            // Because the search re-opens the list, we need a boolean flag to prevent an infinite recursion.
                            if (flag && !this.dataSource.options.serverFiltering && !this.dataItem() && this.text()) {
                                flag = false;
                                this.search(this.text());
                                flag = true;
                            }
                            else {
                                this.list.outerWidth(this.wrapper.outerWidth());
                            }
                        }
                    };

                    element.kendoComboBox(config).data('kendoComboBox').wrapper.data('field', field);
                }
            },
            gridDateTimeFilter: function (dateFormat, noTime) {
                var config = { format: dateFormat };

                if (!noTime) {
                    config.timeFormat = 'HH:mm';
                }

                return {
                    cell: {
                        template: function (args) {
                            if (noTime) {
                                args.element.kendoDatePicker(config);
                            }
                            else {
                                args.element.kendoDateTimePicker(config);
                            }
                            
                        },
                        operator: 'lte'
                    },
                    ui: function (element) {
                        if (noTime) {
                            element.kendoDatePicker(config);
                        }
                        else {
                            element.kendoDateTimePicker(config);
                        }
                    }
                }
            },
            gridDropdownEditor: function (container, fieldName, optionsSelector, kendoOpts, opts, type) {
                if (!kendoOpts) kendoOpts = {};

                type = type || 'kendoDropDownList';

                optionsSelector = $(optionsSelector);
                
                if (optionsSelector.prop('tagName') === 'SELECT'){
                    var options = optionsSelector.children('option');
                    var optionGroups = optionsSelector.children('optgroup');
                    optionsSelector = options.add(optionGroups);
                }

                var dropdown = $('<select name="' + fieldName + '">')
                    .append($(optionsSelector).clone())
                    .appendTo(container);

                if (typeof (dropdown[type]) !== 'function') console.warn('No method named "' + type + '" found.');
                
                //Optgroups aren't supported by kendo, use a default form control when optgroups are used
                if (dropdown.find('optgroup').length){
                    dropdown.addClass('form-control');
                    
                    //Shrink width to accomodate padding
                    var width = dropdown.width() - (dropdown.outerWidth(false) - dropdown.width());
                    dropdown.css({'width': width + 'px', 'height': 'auto' });
                }
                else{
                    dropdown = dropdown[type](kendoOpts);
                }

                if (opts) {
                    //Sometimes a bug occurs causing the value to not be set during initialization of the component
                    if (opts.model.isNew()) {
                        opts.model[fieldName] = dropdown.val();
                    }
                }

                return dropdown;
            },
            gridTextAreaEditor: function (container, fieldName, attributes) {
                attributes = attributes || {};

                $('<textarea />', $.extend({
                    class: 'k-input k-textbox',
                    required: 'required',
                    name: fieldName,
                    'data-bind': 'value:' + fieldName
                }, attributes))
                    .appendTo(container);
            },
            gridTextBoxEditor : function (container, opts, attributes) {
                var control = $('<input />', $.extend({
                    type: 'text',
                    class: 'k-input k-textbox',
                    name: opts.field,
                    'data-bind': 'value:' + opts.field
                }, attributes || {}));
                
                control.val(opts.model[opts.field]);
                control.appendTo(container);
                
                return control;
            },
            gridTimeEditor: function (container, fieldName, format) {
                $('<input data-bind="value:' + fieldName + '" name="' + fieldName + '"/>')
                    .appendTo(container)
                    .kendoTimePicker({ format: format });
            },
            gridPageableForVirtualScrollSettings: function () {
                return {
                    previousNext: false,
                    numeric: false,
                    refresh: true
                }
            },
            gridPageableSettings: function (pageSizes) {
                return {
                    pageSizes: pageSizes || [10, 20, 50, MDB.loadResourceString('DataTable_PageSizes_Unlimited')],
                    messages: {
                        first: MDB.loadResourceString('DataTable_Paginate_First'),
                        next: MDB.loadResourceString('DataTable_Paginate_Next'),
                        previous: MDB.loadResourceString('DataTable_Paginate_Previous'),
                        last: MDB.loadResourceString('DataTable_Paginate_Last'),
                        itemsPerPage: MDB.loadResourceString('DataTable_Kendo_LengthMenu'),
                        display: MDB.loadResourceString('DataTable_Kendo_Info'),
                        empty: MDB.loadResourceString('DataTable_EmptyTable')
                    }
                }
            },
            gridSuppressEditorUnlessAddingRow: function (fieldNames) {
                return function (e) {
                    if (e.model.isNew() === false) {
                        fieldNames.forEach(function (field) {
                            var element = $('[name=' + field + ']');
                            element.closest('td').html(e.model[field]);
                        });
                    }
                }
            },
            imageLinkTemplate: function (fieldName) {
                var template =
                    '#if(' + fieldName + ') {#' +
                    '<div class="pic-icon" data-filename="#=' + fieldName + '#">' +
                    '<i class="fa fa-picture-o"></i>' +
                    '</div>' +
                    '#}#';
                return template;
            },
            imageAsyncUploaderInPopupEditor: function (container, options, saveUrl) {
                var imageName = options.model[options.field];
                $('<input type="text" name="' + options.field + '" class="hidden"/>').appendTo(container);
                $('<input type="file" name="image">')
                    .appendTo(container)
                    .kendoUpload({
                        async: { saveUrl: saveUrl },
                        success: function (e) {
                            var url = $('.k-popup-edit-form').find('input[name="' + options.field + '"]');
                            url.val(e.response);
                            url.trigger('change');

                            var displayedFiles = $('.k-file-success');
                            if (displayedFiles.length > 1) {
                                displayedFiles.first().remove();
                            }
                            e.sender.disable();
                        },
                        error: function (e) { alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e)); },
                        localization: MDB.KendoConfigBuilder.uploadLabels(),
                        multiple: false,
                        files: imageName ? [{ name: imageName }] : []
                    });
            },
            listViewRemoveElementFunc: function (e) {
                e.preventDefault();
                MDB.promptHtml(
                    MDB.loadResourceString('Settings_Widget_WidgetBackgrounds_Delete_Prompt_Title'),
                    MDB.loadResourceString('Settings_Widget_WidgetBackgrounds_Delete_Prompt_Body'),
                    function (ok) {
                        if (ok) {
                            var listView = e.sender.element.data('kendoListView');
                            listView.unbind('remove', MDB.KendoConfigBuilder.listViewRemoveElementFunc);
                            listView.remove(e.item);
                            listView.bind('remove', MDB.KendoConfigBuilder.listViewRemoveElementFunc);
                        }
                    }
                );
            },
            multiDateSeriesTooltip: function (dateField, seriesName) {
                return {
                    visible: true,
                    template: '#= kendo.toString(dataItem.' + dateField + ', "yyyy-MM-dd") #<br/>' + seriesName + ': #= value #'
                }
            },
            multiselectDisableReadonlyTagsRemoval: function (tagList, values) {
                if (_.isArray(values) && values.length > 0) {
                    tagList.find('[data-value]').each(function (i, el) {
                        el = $(el);
                        if (values.some(function (val) { return el.data('value') === val; })) {
                            el.next('.k-delete').remove();
                            var tag = el.closest('.k-button');
                            tag.addClass('readonly')
                                .css('padding-right', tag.css('padding-left'));
                        }
                    });
                }
            },
            multiselectWithReadonlyTags: function (element, readonlyValues, sortable, options) {
                options = options || {};

                var config = {
                    autoClose: false,
                    tagTemplate: '<span data-value="#=' + (options.dataValueField || 'value') + '#">#=' + (options.dataTextField || 'text') + '#</span>',
                    dataBound: function () {
                        var tagList = this.tagList;
                        MDB.KendoConfigBuilder.multiselectDisableReadonlyTagsRemoval(tagList, readonlyValues);

                        if (sortable) {
                            tagList.kendoSortable({
                                container: tagList.parent(),
                                cursor: 'move',
                                change: function () {
                                    var sortedValues = [];
                                    // Extract the values from the tags.
                                    $.each(this.items(), function (idx, item) {
                                        sortedValues.push($(item).find('[data-value]').first().data('value'));
                                    });

                                    // Reorder the seleted elements in the dom, so they get posted in the correct order.
                                    var selectedOptions = element.find('option:selected');
                                    sortedValues.forEach(function (val) {
                                        selectedOptions.filter('[value="' + val + '"]').first().appendTo(element);
                                    });

                                    // Manually set the value, as the multiselect is not affected by the tag value.
                                    element.val(sortedValues);
                                }
                            });
                        }
                    }
                };

                if (sortable) {
                    config.change = function() {
                        this.tagList.data('kendoSortable').trigger('change');
                    };
                }

                $.extend(true, config, options);
                var multiselect = element.kendoMultiSelect(config).data('kendoMultiSelect');

                // TODO: Replace with a deselect event logic in KendoUI version after Q3 2016.
                if (_.isArray(readonlyValues) && readonlyValues.length > 0) {
                    var input = multiselect.input;

                    // Prevent backspace and del from removing items.
                    input.on('keydown', function (e) {
                        if ((e.which === 8 || e.which === 46) && !e.target.value.length) {
                            e.stopImmediatePropagation();
                            e.preventDefault();
                        }
                    });

                    $._data(input[0]).events.keydown.reverse();
                }

                new MutationObserver(function () {
                    MDB.KendoConfigBuilder.multiselectDisableReadonlyTagsRemoval(multiselect.tagList, readonlyValues);
                }).observe(multiselect.tagList.get(0), { childList: true });

                return multiselect;
            },
            setAjaxHeader: function (e) {
                // The AjaxOnlyAttribute will reject requests without this.
                var xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener('readystatechange', function onReady() {
                        if (xhr.readyState === 1) {
                            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                            xhr.removeEventListener('readystatechange', onReady);
                        }
                    });
                }
            },
            singleSeriesTooltip: function (seriesName) {
                return {
                    visible: true,
                    format: '{0}%',
                    template: seriesName + ': #= value #'
                }
            },
            singleImageAsyncUploadConfig: function (uploadUrl, removeUrl, buttonText, otherOptions) {
                var config = {
                    async: {
                        saveUrl: document.location.origin + uploadUrl,
                        removeUrl: document.location.origin + removeUrl,
                        autoUpload: true
                    },
                    multiple: false,
                    localization: MDB.KendoConfigBuilder.uploadLabels(buttonText),
                    error: function (e) {
                        if (e.XMLHttpRequest.status === 400) {
                            $('[data-valmsg-for="' + e.sender.element.attr('id') + '"]')
                                .text(e.XMLHttpRequest.responseText);
                        }
                        else {
                            alert(e.XMLHttpRequest.statusText + ':\n' + e.XMLHttpRequest.responseText);
                        }
                    }
                };
                $.extend(config, otherOptions, true);

                return config;
            },
            singleImageUploadConfig: function (buttonText, otherOptions) {
                var config = {
                    multiple: false,
                    localization: MDB.KendoConfigBuilder.uploadLabels(buttonText)
                }
                $.extend(config, otherOptions, true);

                return config;
            },
            uploadLabels: function (buttonText) {
                return {
                    select: buttonText || MDB.loadResourceString('KendoUpload_Loacalization_Select'),
                    headerStatusUploaded: MDB.loadResourceString('KendoUpload_Loacalization_HeaderStatusUploaded'),
                    dropFilesHere: MDB.loadResourceString('KendoUpload_Loacalization_DropFilesHere')
                }
            },
            emptyEditor: function () {
                return '';
            },
            reloadableGrid: function (e, gridConfig) {
                var grid = e.kendoGrid(gridConfig);
                
                $.extend(grid,
                    {
                        reload: function () {          
                            var kGrid = grid.data('kendoGrid');
                            return kGrid.dataSource.read().done(function() {
                                MDB.KendoConfigBuilder.goBackToLastPageIfGridIsEmpty(gridConfig);
                            });
                        }
                    });
                return grid;
            },
            reloadGrid: function(kGrid){
                //Assume selector
                if(!kGrid.dataSource){
                    kGrid = $(kGrid).data('kendoGrid')
                }
                
                return kGrid.dataSource.read().done(function(){
                    kGrid.refresh();
                    MDB.KendoConfigBuilder.goBackToLastPageIfGridIsEmpty(kGrid);
                });
            },
            hideColumnsOnEdit: function (e) {
                //http://stackoverflow.com/a/34337470
                var labels = e.container.find('.k-edit-label');

                e.sender.columns.forEach(function (element) {
                    if (element.hideOnEdit) {
                        var index = labels.find('label[for="' + element.field + '"]').parent().index();
                        if (index !== 0)
                            index = index / 2;

                        e.container.find('.k-edit-label:eq(' + index + '), ' + '.k-edit-field:eq( ' + index + ')').hide();
                    }
                });
            },
            arrayDataSource: function (arr, kConfig) {
                var dataTextField = 'text';
                var dataValueField = 'value';

                if (kConfig){
                    dataTextField = kConfig.dataTextField || dataTextField;
                    dataValueField = kConfig.dataTextField || dataValueField;
                }

                return new kendo.data.DataSource({ 
                    data: _.map(arr, function (item) {
                        return _.zipObject([dataTextField, dataValueField], [item,  item]);
                    }
                )});
            },
            getSchemaFieldType: function (obj) {
                if (_.isDate(obj) || (_.isString(obj) && obj.length === 19 && /\d{4}(-\d{2}){2}T(\d{2}:){2}\d{2}/.test(obj))){
                    return 'date';
                } 
                
                if (_.isString(obj)){
                    return 'string';
                } 
                
                if (_.isNumber(obj)) {
                    return 'number';
                }
                
                if (_.isBoolean(obj)){
                    return 'boolean';
                } 
                
                return undefined;
            },
            findGridRowModel: function(target){
                var $target = $(target);

                var row = $target.is('tr[data-uid]') ? $target : $target.closest('tr[data-uid]');
                var grid = row.closest('.k-grid').data('kendoGrid');
                
                var ds = grid.dataSource;
                return ds.getByUid(row.data('uid'));
            }
        });
})(jQuery);